const Video = () => {
    // Geçici olarak devre dışı bırakıldı.
    /*
    return (
        <>
        <div className="video__area" style={{backgroundImage: `url(${videoBg})`}}>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="video__area-icon wow fadeInDown" data-wow-delay="0.8s">
                            <div className="video video-pulse">
                                <span onClick={openVideoModal}><i className="fas fa-play"></i></span>
                            </div>						
                        </div>
                    </div>
                </div>
            </div>
        </div>    
        <ModalVideo className='video-modal' channel="youtube" autoplay isOpen={openVideo} videoId="SZEflIVnhH8" onClose={() => setOpenVideo(false)} />        
        </>
    );
    */
    return null;
};

export default Video;